module.exports = __webpack_public_path__ + "03_very_short_yellow.15036c82.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/03_very_short_yellow.png
// module id = Cb7q
// module chunks = 0